import { useCallback, useEffect, useState } from 'react';
import serviceCommons from 'services/commons';
import serviceResiduos from 'services/residuos';
import serviceEmpresa from 'services/empresas';
import serviceRoles from 'services/roles';
import serviceGrupos from 'services/grupos';
import { DICTONARY } from 'const/Dictonary';
import recursosServices from 'services/recursos';
import { AlertaError, AlertaWarning } from 'utils/Alertas';
import { limpiaParametrosVacios } from 'helpers/manejoLLamadasServicios';

/**
 * Servicio Nombre LER (ObtieneListaLer)
 * @returns
 **/

export const ObtieneListaLer = () => {
  const [listaLer, setListaLer] = useState([]);
  const [cargandoListaLer, setCargandoListaLer] = useState(true);
  const [listaLerNivelUno, setListaLerNivelUno] = useState([]);
  // Edición
  const [listaLerNivelUnoEdit, setListaLerNivelUnoEdit] = useState([]);
  const [listaLerNivelDosEdit, setListaLerNivelDosEdit] = useState([]);
  const [listaLerNivelTresEdit, setListaLerNivelTresEdit] = useState([]);

  const handleListaLer = useCallback(async () => {
    const params = {
      totalPagina: DICTONARY.PAGINACION.ALL_DATA,
      ordenarPor: 'nombreLER'
    };
    setCargandoListaLer(true);
    try {
      const response = await serviceCommons.nombresLER(params);

      const { content, empty } = response.data;
      if (response.status === 200 && !empty) {
        setListaLer(content);
        setListaLerNivelUno(content.filter(rsd => rsd.nivel === 1));
        // Solo edición
        setListaLerNivelUnoEdit(content.filter(rsd => rsd.nivel === 1));
        setListaLerNivelDosEdit(content.filter(rsd => rsd.nivel === 2));
        setListaLerNivelTresEdit(content.filter(rsd => rsd.nivel === 3));
      } else {
        setListaLer([]);
      }
    } catch (error) {
      setListaLer([]);
      console.log(error);
    } finally {
      setCargandoListaLer(false);
    }
  }, []);

  useEffect(() => {
    handleListaLer();
  }, [handleListaLer]);

  return {
    listaLer,
    cargandoListaLer,
    handleListaLer,
    listaLerNivelUno,
    listaLerNivelUnoEdit,
    listaLerNivelDosEdit,
    listaLerNivelTresEdit
  };
};

/**
 * Carga Info Residuo a Editar (ObtieneInfoResiduo)
 * @param {string} codigoResiduo
 * @returns
 **/
export const ObtieneInfoResiduo = codigoResiduo => {
  const [cargando, setCargando] = useState(true);
  // Lista de residuo seleccionado
  const [listaResiduo, setListaResiduo] = useState([]);
  const [error, setError] = useState(null);

  const cargaListaResiduo = useCallback(async () => {
    try {
      setCargando(true);
      const response = await serviceResiduos.obtenerResiduo(codigoResiduo);
      if (response.data) {
        const resultTemp = response.data;
        setListaResiduo(resultTemp);
      } else {
        setListaResiduo([]);
        setError(new Error('Residuo no encontrado'));
      }
    } catch (error) {
      setListaResiduo([]);
      console.log('Error al cargar residuo:', error);
      setError(new Error('Error al cargar residuo.'));
    } finally {
      setCargando(false);
    }
  }, [codigoResiduo]);

  useEffect(() => {
    // CARGAR INFORMACION DEL RESIDUO
    if (codigoResiduo) {
      cargaListaResiduo();
    }
  }, [cargaListaResiduo, codigoResiduo]);

  return {
    cargando,
    listaResiduo,
    error,
    cargaListaResiduo
  };
};

/**
 *  Servicio Tipo Residuos (ObtieneListaTipoResiduos)
 */
export const ObtieneListaTipoResiduos = () => {
  const [listaTipoResiduos, setListaTipoResiduos] = useState([]);
  const [cargandoListaTipoResiduos, setCargandoListaTipoResiduos] =
    useState(true);
  const [listaTipoResiduosNivelUno, setTipoResiduosNivelUno] = useState([]);
  // Edición
  const [listaTipoResiduoNivelUnoEdit, setTipoResiduoNivelUnoEdit] = useState(
    []
  );
  const [listaTipoResiduoNivelDosEdit, setTipoResiduoNivelDosEdit] = useState(
    []
  );

  const handleTipoResiuduos = useCallback(async () => {
    const params = {
      totalPagina: DICTONARY.PAGINACION.ALL_DATA,
      ordenarPor: 'nombreTipo'
    };
    setCargandoListaTipoResiduos(true);
    try {
      const response = await serviceCommons.tipoRSD(params);
      const { content, empty } = response.data;
      if (response.status === 200 && !empty) {
        setListaTipoResiduos(content);
        setTipoResiduosNivelUno(content.filter(rsd => rsd.nivel === 1));
        // Solo edición
        setTipoResiduoNivelUnoEdit(content.filter(rsd => rsd.nivel === 1));
        setTipoResiduoNivelDosEdit(content.filter(rsd => rsd.nivel === 2));
      } else {
        setListaTipoResiduos([]);
      }
    } catch (error) {
      setListaTipoResiduos([]);
      console.log(error);
    } finally {
      setCargandoListaTipoResiduos(false);
    }
  }, []);

  useEffect(() => {
    handleTipoResiuduos();
  }, [handleTipoResiuduos]);

  return {
    listaTipoResiduos,
    cargandoListaTipoResiduos,
    handleTipoResiuduos,
    listaTipoResiduosNivelUno,
    listaTipoResiduoNivelUnoEdit,
    listaTipoResiduoNivelDosEdit
  };
};

/**
 * Servicio Tipo Recursos (ObtieneListaTipoRecursos)
 * @returns
 */
export const ObtieneListaRecursos = () => {
  const [listaRecursos, setListaRecursos] = useState([]);
  const [cargandoListaRecursos, setCargandoListaRecursos] = useState(true);

  const handleRecursos = useCallback(async () => {
    const params = {
      totalPagina: DICTONARY.PAGINACION.ALL_DATA,
      ordernarPor: 'nombreRecurso'
    };
    const conInterceptor = false;
    setCargandoListaRecursos(true);
    try {
      const response = await serviceCommons.recursos(params, conInterceptor);
      const { content, empty } = response.data;
      if (response.status === 200 && !empty) {
        setListaRecursos(content);
      } else {
        setListaRecursos([]);
      }
    } catch (error) {
      setListaRecursos([]);
      console.log(error);
    } finally {
      setCargandoListaRecursos(false);
    }
  }, []);

  useEffect(() => {
    handleRecursos();
  }, [handleRecursos]);

  return {
    listaRecursos,
    cargandoListaRecursos,
    handleRecursos
  };
};

/**
 * Servicio Tipo Recursos por codigo (ObtieneTipoRecursosPorCodigosTipoRecursos)
 * @param {string} codigosTipoResiduo
 * @returns
 */
export const ObtieneTipoRecursosPorCodigosTipoRecursos = codigosTipoResiduo => {
  const [listaTipoRecursos, setListaTipoRecursos] = useState([]);
  const [cargandoListaTipoRecursos, setCargandoListaTipoRecursos] =
    useState(true);

  const handleTipoRecursos = useCallback(async () => {
    if (!codigosTipoResiduo) {
      setListaTipoRecursos([]);
      setCargandoListaTipoRecursos(false);
      return;
    }
    const params = {
      totalPagina: DICTONARY.PAGINACION.ALL_DATA,
      codigosTipoResiduo: codigosTipoResiduo,
      ordenarPor: 'nombreRecurso'
    };
    const conInterceptor = false;

    setCargandoListaTipoRecursos(true);
    try {
      const response = await serviceCommons.recursos(params, conInterceptor);
      const { data } = response;

      const { content, empty } = data;

      if (response.status === 200 && !empty) {
        if (Array.isArray(content)) {
          setListaTipoRecursos(content);
        } else {
          setListaTipoRecursos([]);
        }
      } else {
        setListaTipoRecursos([]);
        return;
      }
    } catch (error) {
      console.log(error);
      setListaTipoRecursos([]);
    } finally {
      setCargandoListaTipoRecursos(false);
    }
  }, [codigosTipoResiduo]);

  useEffect(() => {
    handleTipoRecursos();
  }, [handleTipoRecursos]);

  return {
    listaTipoRecursos,
    cargandoListaTipoRecursos,
    handleTipoRecursos
  };
};

/**
 * Servicio Tipo Recursos por codigo (ObtieneTipoRecursosPorCodigosTipoRecursos)
 * @param {string} codigoRecursoReemplazo
 * @param {Function} setRecursoReemplazo
 * @param {Function} setCargandoRecursoReemplazo
 */
export const ObtieneRecursoReemplazoFiltrado = async ({
  codigoRecursoReemplazo,
  setRecursoReemplazo,
  setCargandoRecursoReemplazo
}) => {
  try {
    const response = await serviceCommons.obtieneRecursoReemplazo();
    if (response.status === 200) {
      const { data } = response;
      const { content } = data;

      const recursoReemplazoFiltrado = content.filter(
        r =>
          r.codigoRecursoReemplazo === codigoRecursoReemplazo && r.nivel === 1
      );
      setRecursoReemplazo(recursoReemplazoFiltrado[0]);
    }
  } catch (error) {
    setRecursoReemplazo([]);
    AlertaError(
      'Ha ocurrido un error al obtener recurso de reemplazo, si el problema persiste comunícate con el administrador del sitio'
    );
    return error;
  } finally {
    setCargandoRecursoReemplazo(false);
  }
};

/**
 * Servicio Sucursales (ObtieneListaSucursales)
 * @param {string} codigoEmpresaState
 * @returns
 */
export const ObtieneListaSucursales = codigoEmpresaState => {
  const [listaSucursales, setListaSucursales] = useState([]);
  const [cargandoListaSucursales, setCargandoListaSucursales] = useState(true);

  const handleListaSucursales = useCallback(async () => {
    const params = {};
    if (codigoEmpresaState) {
      params.codigoEmpresa = codigoEmpresaState;
    }
    const conInterceptor = false;
    setCargandoListaSucursales(true);
    try {
      const response = await serviceEmpresa.obtenerListaSucursales(
        params,
        conInterceptor
      );
      if (response.status === 200 && Array.isArray(response.data)) {
        setListaSucursales(response.data);
      } else {
        setListaSucursales([]);
      }
    } catch (error) {
      setListaSucursales([]);
      console.log(error);
    } finally {
      setCargandoListaSucursales(false);
    }
  }, [codigoEmpresaState]);

  useEffect(() => {
    handleListaSucursales();
  }, [handleListaSucursales]);

  return {
    listaSucursales,
    cargandoListaSucursales,
    handleListaSucursales
  };
};

/**
 * Servicio Tipo Disposicion (ObtieneListaTipoDisposicion)
 * @param {string} codigoTipoResiduo
 * @returns
 */
export const ObtieneListaTipoDisposicion = codigoTipoResiduo => {
  const [listaTipoDisposicion, setListaTipoDisposicion] = useState([]);
  const [cargandoListaTipoDisposicion, setCargandoListaTipoDisposicion] =
    useState(true);

  const handleListaTipoDisposicion = useCallback(async () => {
    if (!codigoTipoResiduo) return;
    // const params = {
    //   codigosTipoResiduo: codigoTipoResiduo,
    //   totalPagina: DICTONARY.PAGINACION.ALL_DATA
    // };
    const conInterceptor = false;
    setCargandoListaTipoDisposicion(true);
    try {
      const response = await serviceCommons.tipodisposicion(
        {
          codigosTipoResiduo: codigoTipoResiduo,
          ordenarPor: 'nombreDisposicion',
          totalPagina: DICTONARY.PAGINACION.ALL_DATA
        },
        conInterceptor
      );
      const { content, empty } = response.data;
      if (response.status === 200 && !empty) {
        setListaTipoDisposicion(content);
      } else {
        setListaTipoDisposicion([]);
      }
    } catch (error) {
      setListaTipoDisposicion([]);
      console.log(error);
    } finally {
      setCargandoListaTipoDisposicion(false);
    }
  }, [codigoTipoResiduo]);

  useEffect(() => {
    handleListaTipoDisposicion();
  }, [handleListaTipoDisposicion]);

  return {
    listaTipoDisposicion,
    cargandoListaTipoDisposicion,
    handleListaTipoDisposicion
  };
};

/**
 * Servicio Tipo Recurso Reemplazo (ObtieneListaTipoRecursoReemplazo)
 * @returns
 */
export const ObtieneListaTipoRecursoReemplazo = () => {
  const [listaTipoRecursoReemplazo, setListaTipoRecursoReemplazo] = useState(
    []
  );
  const [listaTipoRecursoReemplazo2, setListaTipoRecursoReemplazo2] = useState(
    []
  );

  const [
    cargandoListaTipoRecursoReemplazo,
    setCargandoListaTipoRecursoReemplazo
  ] = useState(true);

  const handleListaTipoRecursoReemplazo = useCallback(async () => {
    const params = {
      totalPagina: DICTONARY.PAGINACION.ALL_DATA,
      ordenarPor: 'nombreRecursoReemplazo'
    };
    const conInterceptor = false;
    setCargandoListaTipoRecursoReemplazo(true);
    try {
      const response = await serviceCommons.obtieneRecursoReemplazo(
        params,
        conInterceptor
      );
      const { content, empty } = response.data;
      if (response.status === 200 && !empty) {
        setListaTipoRecursoReemplazo(content.filter(r => r.nivel === 1));
        setListaTipoRecursoReemplazo2(content.filter(r => r.nivel !== 1));
      } else {
        setListaTipoRecursoReemplazo([]);
      }
    } catch (error) {
      setListaTipoRecursoReemplazo([]);
      console.log(error);
    } finally {
      setCargandoListaTipoRecursoReemplazo(false);
    }
  }, []);

  useEffect(() => {
    handleListaTipoRecursoReemplazo();
  }, [handleListaTipoRecursoReemplazo]);

  return {
    listaTipoRecursoReemplazo,
    listaTipoRecursoReemplazo2,
    cargandoListaTipoRecursoReemplazo,
    handleListaTipoRecursoReemplazo
  };
};

/**
 * Valida Si Existe Recurso (ValidaSiExisteRecurso)
 * @param {Array} listaRecursos
 * @param {string} nombre
 * @returns
 */
export const ValidaSiExisteRecurso = ({ listaRecursos, nombre }) => {
  // Verifica si el nombre está presente
  if (!nombre) return false;

  // Convierte todo a minúsculas para hacer la comparación insensible a mayúsculas
  const nombreLowerCase = nombre.trim().toLowerCase();

  // Utiliza find en lugar de filter, ya que solo necesitas la primera coincidencia
  const existeNombreRecurso = listaRecursos.find(
    r => r.nombreRecurso.trim().toLowerCase() === nombreLowerCase
  );

  // Imprime el resultado en la consola
  // console.log(existeNombreRecurso);

  // Retorna true si existe el nombre y false en caso contrario
  return Boolean(existeNombreRecurso);
};

/**
 * Obtiene Codigo Recurso Existe (ObtieneCodigoRecursoExiste)
 * @param {Array} listaRecursos
 * @param {string} nombre
 * @returns
 */
export const ObtieneCodigoRecursoExiste = ({ listaRecursos, nombre }) => {
  // Verifica si el nombre está presente
  if (!nombre) return false;

  // Convierte todo a minúsculas para hacer la comparación insensible a mayúsculas
  const nombreLowerCase = nombre.trim().toLowerCase();

  // Utiliza find en lugar de filter, ya que solo necesitas la primera coincidencia
  const existeNombreRecurso = listaRecursos.find(
    r => r.nombreRecurso.trim().toLowerCase() === nombreLowerCase
  );

  // Imprime el resultado en la consola
  // console.log(existeNombreRecurso);

  // Retorna true si existe el nombre y false en caso contrario
  return {
    codigoRecurso: existeNombreRecurso.codigoRecurso,
    nombreRecurso: existeNombreRecurso.nombreRecurso
  };
};

/**
 * Servicio Lista de Transporte (ObtieneListaTransporte)
 * @returns
 */
export const ObtieneListaTipoTransporte = () => {
  const [listaTipoTransporte, setListaTipoTransporte] = useState([]);
  const [isLoadingTipoTransporte, setIsLoadingTipoTransporte] = useState(true);

  const handleListaTipoTransporte = useCallback(async () => {
    const params = {
      totalPagina: DICTONARY.PAGINACION.ALL_DATA,
      ordernarPor: 'nombreTipoTransporte'
    };
    const conInterceptor = false;
    try {
      const response = await serviceEmpresa.obtenerTipoTransaporte(
        params,
        conInterceptor
      );
      const { content, empty } = response.data;

      if (response.status === 200 && !empty) {
        setListaTipoTransporte(content);
      } else {
        setListaTipoTransporte([]);
      }
    } catch (error) {
      setListaTipoTransporte([]);
      console.log(error);
    } finally {
      setIsLoadingTipoTransporte(false);
    }
  }, []);

  useEffect(() => {
    handleListaTipoTransporte();
  }, [handleListaTipoTransporte]);

  return {
    listaTipoTransporte,
    isLoadingTipoTransporte,
    handleListaTipoTransporte
  };
};
export const ObtieneListaTipoTratamiento = () => {
  const [listaTipoTratamiento, setListaTipoTratamiento] = useState([]);
  const [isLoadingTipoTratamiento, setIsLoadingTipoTratamiento] =
    useState(true);

  const handleListaTipoTratamiento = useCallback(async customParams => {
    setIsLoadingTipoTratamiento(true);
    const params = {
      totalPagina: DICTONARY.PAGINACION.ALL_DATA,
      ordenarPor: 'nombreTipoTratamiento'
    };
    const conInterceptor = false;
    try {
      const response = await serviceResiduos.obtenerListaTipoTratamiento(
        customParams ? customParams : params,
        conInterceptor
      );
      const { content, empty } = response.data;

      if (response.status === 200 && !empty) {
        // evitar duplicados  y ordenar por nombre
        const contentFiltrado = content.filter(
          (v, i, a) =>
            a.findIndex(
              t => t.nombreTipoTratamiento === v.nombreTipoTratamiento
            ) === i
        );
        setListaTipoTratamiento(contentFiltrado);
      } else {
        setListaTipoTratamiento([]);
      }
    } catch (error) {
      setListaTipoTratamiento([]);
      console.log(error);
    } finally {
      setIsLoadingTipoTratamiento(false);
    }
  }, []);

  useEffect(() => {
    handleListaTipoTratamiento();
  }, [handleListaTipoTratamiento]);

  return {
    listaTipoTratamiento,
    isLoadingTipoTratamiento,
    handleListaTipoTratamiento
  };
};

export const ObtieneLevantamiento = () => {
  const [isLoadingLevantamiento, setIsLoadingLevantamiento] = useState(true);
  const [levantamiento, setLevantamiento] = useState([]);

  const handleLevantamiento = useCallback(async () => {
    const params = {
      totalPagina: DICTONARY.PAGINACION.ALL_DATA,
      ordenarPor: 'nombreLevantamientoDatos'
    };
    const conInterceptor = false;
    try {
      const response = await serviceResiduos.obtieneLevantamientoDatos(
        params,
        conInterceptor
      );
      const { content, empty } = response.data;
      if (response.status === 200 && !empty) {
        setLevantamiento(content);
      } else {
        setLevantamiento([]);
      }
    } catch (err) {
      console.log('err :>> ', err);
      setLevantamiento([]);
    } finally {
      setIsLoadingLevantamiento(false);
    }
  }, []);

  useEffect(() => {
    handleLevantamiento();
  }, [handleLevantamiento]);

  return {
    levantamiento,
    isLoadingLevantamiento,
    handleLevantamiento
  };
};

export const ObtieneUnidadMedida = () => {
  // States Campos de Unidad de Medida
  const [unidadMedida, setUnidadMedida] = useState([]);
  const [isLoadingUnidadMedida, setIsLoadingUnidadMedida] = useState(true);

  const handleUnidadMedida = useCallback(async () => {
    try {
      const response = await recursosServices.obtieneUnidadMedida({
        ordenarPor: 'nombreUnidadMedida',
        totalPagina: DICTONARY.PAGINACION.ALL_DATA
      });
      if (response.status === 200) {
        const { content, totalElements, empty } = response.data;
        if (empty) {
          console.log('No hay unidades de medida disponibles ::>');
          setUnidadMedida([]);
          throw new Error('SIN_REGISTROS');
        } else if (Array.isArray(content)) {
          setUnidadMedida(content);
        }
      }
    } catch (err) {
      console.log('err :>> ', err);
      setUnidadMedida([]);
      if (err.message === 'SIN_REGISTROS') {
        AlertaWarning('No hay unidades de medida disponibles');
      }
      if (
        !err.response ||
        !err.response.data ||
        !err.response.data.codigoError
      ) {
        console.log(
          'Ha ocurrido un error al obtener las unidades de medida, si el problema persiste comunícate con el administrador del sitio',
          err
        );
        AlertaWarning('No hay unidades de medida disponibles');
      }
    } finally {
      setIsLoadingUnidadMedida(false);
    }
  }, []);

  useEffect(() => {
    if (!unidadMedida) return;
    handleUnidadMedida();
  }, [handleUnidadMedida]);

  return {
    unidadMedida,
    isLoadingUnidadMedida,
    handleUnidadMedida
  };
};

export const ObtieneRoles = () => {
  const [roles, setRoles] = useState([]);
  const [isLoadingRoles, setIsLoadingRoles] = useState(true);

  const handleRoles = useCallback(async () => {
    try {
      const response = await serviceRoles.roles({
        ordenarPor: 'nombreRol',
        totalPagina: DICTONARY.PAGINACION.ALL_DATA
      });
      if (response.status === 200) {
        const { content, empty } = response.data;
        if (empty) {
          console.log('No hay roles disponibles ::>');
          setRoles([]);
          throw new Error('SIN_REGISTROS');
        } else if (Array.isArray(content)) {
          setRoles(content);
        }
      }
    } catch (err) {
      setRoles([]);
      if (err.message === 'SIN_REGISTROS') {
        AlertaWarning('No hay roles disponibles');
      }
      if (
        !err.response ||
        !err.response.data ||
        !err.response.data.codigoError
      ) {
        console.log(
          'Ha ocurrido un error al obtener los roles, si el problema persiste comunícate con el administrador del sitio',
          err
        );
        AlertaWarning('No hay roles disponibles');
      }
    } finally {
      setIsLoadingRoles(false);
    }
  }, []);

  useEffect(() => {
    handleRoles();
  }, []);

  return {
    roles,
    isLoadingRoles,
    handleRoles
  };
};

export const ObtieneGrupos = () => {
  const [grupos, setGrupos] = useState([]);
  const [isLoadingGrupos, setIsLoadingGrupos] = useState(true);

  const handleGrupos = useCallback(async () => {
    try {
      const response = await serviceGrupos.obtenerLista({
        ordenarPor: 'nombreGrupo'
      });
      if (response.status === 200) {
        setGrupos(response.data);
      }
    } catch (err) {
      setGrupos([]);
      if (err.message === 'SIN_REGISTROS') {
        AlertaWarning('No hay roles disponibles');
      }
      if (
        !err.response ||
        !err.response.data ||
        !err.response.data.codigoError
      ) {
        console.log(
          'Ha ocurrido un error al obtener los roles, si el problema persiste comunícate con el administrador del sitio',
          err
        );
        AlertaWarning('No hay roles disponibles');
      }
    } finally {
      setIsLoadingGrupos(false);
    }
  }, []);

  useEffect(() => {
    handleGrupos();
  }, []);

  return {
    grupos,
    isLoadingGrupos,
    handleGrupos
  };
};

export const ObtieneUnGrupo = () => {
  const [grupo, setGrupo] = useState([]);
  const [isLoadingGrupo, setIsLoadingGrupo] = useState(false);

  const handleGrupo = useCallback(async codigoGrupo => {
    try {
      setIsLoadingGrupo(true);
      const response = await serviceGrupos.getGrupo(codigoGrupo);
      if (response.status === 200) {
        setGrupo(response.data);
      }
    } catch (err) {
      setGrupo({});
      if (err.message === 'SIN_REGISTROS') {
        AlertaWarning('No hay roles disponibles');
      }
      if (
        !err.response ||
        !err.response.data ||
        !err.response.data.codigoError
      ) {
        console.log(
          'Ha ocurrido un error al obtener los roles, si el problema persiste comunícate con el administrador del sitio',
          err
        );
        AlertaWarning('No hay roles disponibles');
      }
    } finally {
      setIsLoadingGrupo(false);
    }
  }, []);

  return {
    grupo,
    isLoadingGrupo,
    handleGrupo
  };
};

/**
 *
 * @returns ObtieneListaDeEmpresas
 *
 * Servicio Lista de Empresas (ObtieneListaDeEmpresas) para usuarios que administran sucursales
 * @param {*} codigoEmpresa Código de la empresa seleccionada
 * @param {*} isAsociados Boolean = true o false. Se usa para indicar si las empresas deben estar filtradas por las que el usuario tiene permiso en sus sucursales.
 *
 */
export const ObtieneListaDeEmpresas = ({
  codigoEmpresa,
  isAsociados,
  codigoRol = null,
  nombreEmpresa = null
}) => {
  const [empresas, setEmpresas] = useState([]);
  const [isLoadingEmpresas, setIsLoadingEmpresas] = useState(true);
  const [empresaSeleccionada, setEmpresaSeleccionada] = useState(null);

  const cargarListaEmpresas = useCallback(async () => {
    setIsLoadingEmpresas(true);

    const params = {
      asociados: isAsociados,
      codigoRol,
      nombreEmpresa
    };

    // Filtrar parámetros nulos
    const filteredParams = limpiaParametrosVacios(params);

    try {
      const response = await serviceEmpresa.obtenerListaEmpresas(
        filteredParams
      );

      if (response.data.error) {
        throw new Error('ERROR_AL_CARGAR_EMPRESAS');
      }
      const empresasAux = response.data.map(empresa => ({
        codigoEmpresa: empresa.codigoEmpresa,
        nombreEmpresa: empresa.nombreEmpresa
      }));

      if (!isNaN(codigoEmpresa)) {
        setEmpresaSeleccionada(
          empresasAux.find(item => item.codigoEmpresa === codigoEmpresa)
        );
      }

      setEmpresas(empresasAux);
    } catch (error) {
      console.error('Error al cargar las empresas:', error);
      setEmpresas([]);
    } finally {
      setIsLoadingEmpresas(false);
    }
  }, [codigoEmpresa]);

  return {
    empresas,
    isLoadingEmpresas,
    empresaSeleccionada,
    setEmpresaSeleccionada,
    cargarListaEmpresas
  };
};

/**
 *
 * @returns ObtieneListaDeSucursales
 *
 * Servicio Lista de Sucursales (ObtieneListaDeSucursales) para usuarios que administran sucursales
 */
export const ObtieneListaDeSucursales = ({
  codigoEmpresaSeleccionado,
  isAsociados
}) => {
  const [sucursales, setSucursales] = useState([]);
  const [isLoadingSucursales, setIsLoadingSucursales] = useState(true);

  const cargarListaSucursales = useCallback(
    async codigoEmpresa => {
      setIsLoadingSucursales(true);
      // Validación inicial
      const codigo = codigoEmpresaSeleccionado || codigoEmpresa;
      if (isNaN(codigo)) {
        setIsLoadingSucursales(false);
        return;
      }

      const params = {
        asociados: isAsociados,
        codigoEmpresa: codigo
      };

      console.log('FETCH_CARGAR_LISTA_SUCURSALES', params);

      try {
        const response = await serviceEmpresa.obtenerListaSucursales(params);

        // console.log('response', response.config.params);

        if (response.data.error) {
          throw new Error('ERROR_AL_CARGAR_SUCURSALES');
        }
        const listaSucursales = response.data;
        // console.log('listaSucursales', listaSucursales);
        // Obtenemos información adicional de las sucursales
        const sucursalesDetalladas = await Promise.all(
          listaSucursales.map(async sucursal => {
            try {
              const responseSucursal = await serviceEmpresa.getSucursal(
                sucursal.codigoSucursal
              );
              return responseSucursal?.data || null;
            } catch {
              return null; // Si una sucursal falla, devolvemos null
            }
          })
        );

        // Filtrar sucursales válidas
        setSucursales(sucursalesDetalladas.filter(Boolean));
      } catch (error) {
        console.error('Error al cargar las sucursales:', error);
        setSucursales([]);
      } finally {
        setIsLoadingSucursales(false);
      }
    },
    [codigoEmpresaSeleccionado]
  );

  return {
    sucursales,
    isLoadingSucursales,
    cargarListaSucursales
  };
};
